var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16.146,
  height: 16.146,
  viewBox: "0 0 16.146 16.146",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-info",
  "data-name": "Icon material-info",
  d: "M11.073,3a8.073,8.073,0,1,0,8.073,8.073A8.076,8.076,0,0,0,11.073,3Zm.807,12.11H10.266V10.266h1.615Zm0-6.459H10.266V7.037h1.615Z",
  transform: "translate(-3 -3)",
  fill: "#0072ce"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/infoIcon.abe247c2d96a5d0c93061265900289d7.svg";